/**
 * Experience bounds are optional. Zero is an agent placeholder, not a real range.
 */
export const normalizeRequirementRange = (
    value: string | number | null | undefined
): string => {
    if (value === null || value === undefined) {
        return '';
    }
    const text = String(value).trim();
    if (text === '' || text === '0') {
        return '';
    }
    return text;
};
